import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/uber/menu';

const sync = (merchantId, branchId, operateBy) => {
	return Client.post(
		`${baseUrl}/${merchantId}/${branchId}/upload`,
		{},
		{
			operateBy,
		}
	);
};

const syncLogs = (merchantId, branchId) => {
	return Client.get(`${baseUrl}/${merchantId}/${branchId}/uploadMenuRecords`);
};

export default {
	sync,
	syncLogs,
};
